const items = [
  "🔥 年度反转之王：一张旧截图引爆全网联想，剧情三天反转三次",
  "🔥 直播带货剧本式砍价被扒，行业连夜自查",
  "🔥 选秀成团夜排名乌龙，牵动千万票池",
  "🔥 一句话带火一座城，年度玩梗地图出炉",
  "🔥 素人综艺靠真实感意外封神，连续登顶话题榜",
];

export default function Ticker() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-b border-primary-200/70 bg-primary-500 text-background-50">
      <div className="flex items-center">
        <div className="relative z-10 flex shrink-0 items-center gap-1.5 bg-foreground-950 px-4 py-2 text-xs font-bold tracking-widest">
          <i className="ri-sparkling-2-fill"></i>
          实时热讯
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-ticker flex w-max items-center gap-12 px-6 py-2">
            {row.map((t, i) => (
              <span key={i} className="whitespace-nowrap text-sm font-medium text-background-50">
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}